import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
export const getNextDate = (latestReportDate) => {
    let nextReportDate = dayjs(latestReportDate).add(1, 'day');
    if (dayjs(nextReportDate).isBefore(dayjs())) {
        nextReportDate = dayjs();
    }
    return nextReportDate.format('YYYY-MM-DD');
};
export const getReportPublishTime = (date, publishTime) => {
    return dayjs(date)
        .startOf('day')
        .add(publishTime.hour, 'hour')
        .tz(publishTime.timezone, true)
        .utc();
};
export const getRemainingMinutesToPublish = (reportDate, publishTime) => {
    const reportPublishTime = getReportPublishTime(reportDate, publishTime);
    const currentTime = dayjs();
    return reportPublishTime.diff(currentTime, 'minutes');
};
export const minutesToHM = (totalMinutes) => {
    let suffix = 'left';
    if (totalMinutes < 0) {
        suffix = 'passed!';
        totalMinutes = Math.abs(totalMinutes);
    }
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours ? hours + ' hrs ' : ''}${minutes} min ${suffix}`;
};
export const fromNow = (date) => dayjs(date).fromNow();
